
//公共库
import { Message } from "element-ui";
import { Component, Vue } from "vue-property-decorator";

//本地引入
import Pagination from "@/comp/Pagination/index.vue";
import { materialList, materialSave } from "@/api/request/user";

//组件
@Component({
  name: "MaterialList",
  components: {
    Pagination,
  },
})

//界面函数
export default class extends Vue {
  //定义变量
  private list: any[] = [];
  private total: number = 0;
  private listLoading: boolean = true;

  //请求数据
  private listQuery: any = {
    //页面数据
    page: 0,
    page_size: 20,

    //临时数据
    user_id_str: "",

    //数据
    user_id: 0,
    user_type: -1,
  };

  //注册类型
  private userTypeList: any[] = [
    { type: -1, name: "全部用户类型" },
    { type: 0, name: "用户" },
    { type: 1, name: "博主" },
  ];

  //创建
  created() {
    //获取数据
    this.getList();
  }

  //获取数据
  private async getList() {
    //显示等待
    this.listLoading = true;

    //数据赋值
    this.listQuery.user_id = Number(this.listQuery.user_id_str);

    //获取数据
    const { data } = await materialList(this.listQuery);

    //数据赋值
    this.list = data.list;
    this.total = data.total;

    //隐藏等待
    setTimeout(() => {
      this.listLoading = false;
    }, 0.5 * 1000);
  }

  //处理查询
  private handleFilter(): void {
    //数据赋值
    this.listQuery.page = 1;

    //获取数据
    this.getList();
  }

  //编辑用户资料
  private handleSave(row: any, type: string): void {
    //数据赋值
    this.setQuery.key = type;
    this.setQuery.id = row.id;
    this.maxNum = type == "declaration" ? 140 : 15;
    this.setTitle = type == "nickname" ? "设置用户昵称" : type == "declaration" ? "设置交友宣言" : "设置职业";
    this.setQuery.value = type == "nickname" ? row["nick_name"] : type == "declaration" ? row["declaration"] : row["profession"];

    //显示界面
    this.setDialog = true;
  }

  //------------------------------- 选择类型 -------------------------------
  //定义变量
  private maxNum: number = 15;
  private setTitle: string = "";
  private setDialog: boolean = false;
  private setLoading: boolean = false;

  //用户类型
  private setQuery: any = {
    //请求数据
    id: 0,
    key: "",
    value: "",
  };

  //修改类型
  private async setConfirm() {
    //判断返回
    if (this.setQuery.value == "") return Message({ message: "请输入" + this.setTitle, type: "error", duration: 5 * 1000 });

    //显示等待
    this.setLoading = true;

    //超时隐藏
    setTimeout(() => {
      this.setLoading = false;
    }, 5000);

    //数据请求
    const res = await materialSave(this.setQuery);

    //修改成功
    if (res.status === 0) {
      //显示提示
      this.$message.success(`设置成功`);

      //隐藏对话框
      this.setLoading = false;
      this.setDialog = false;

      //获取数据
      this.getList();
    }
  }
}
